import React from 'react';
import DateRangeFilter from 'components/list/Filters/types/DateRangeFilter';

const DestinationArrivalDateFilters = <DateRangeFilter
    floatingLabelFixed={ true }
    fullWidth={ true }
    label='filters.components.destinationArrivalDate.label'
    placeholder='filters.components.destinationArrivalDate.placeholder'
    source='destination_arrival_date'
/>;

export default DestinationArrivalDateFilters;



// WEBPACK FOOTER //
// ./src/components/form/filters/DestinationArrivalDateFilter.js